module.exports = __webpack_public_path__ + "static/img/8.69517112.jpg";